module.exports = __webpack_public_path__ + "files/04cabd153198c72a77c6c4a22136caf4.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-32x32.png
// module id = 1249
// module chunks = 76